/** Gets all environments from the core API */
import { request } from "@prismicio/editor-support/Http"
import { useRequest } from "@prismicio/editor-support/Suspense"
import { z } from "zod"

import { baseUrl } from "../../app/services/core"
import { getRepositoryName } from "../routing"

export function getAllEnvironments() {
  const url = new URL("environments", baseUrl)
  return request(url, { okType: getAllEnvironmentsOkType })
}

const Environment = z.object({
  kind: z.enum(["prod", "stage", "dev"]),
  name: z.string(),
  domain: z.string(),
})

export type Environment = z.infer<typeof Environment>

const getAllEnvironmentsOkType = z.object({
  results: z.array(Environment),
})

export function useEnvironments() {
  const { results: environments } = useRequest(getAllEnvironments, [])

  const repositoryName = getRepositoryName()
  const currentEnvironment = environments.find(
    (env) => env.domain === repositoryName,
  )
  const otherEnvironments = environments.filter(
    (env) => env.domain !== repositoryName,
  )

  return {
    environments,
    otherEnvironments,
    currentEnvironment,
  }
}
